import { Component, ViewChild, ViewChildren, QueryList, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { MainService } from './core/main.service';
import { AppConfig } from '../environments/environment';
import { BrowserModule, DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import {Title} from "@angular/platform-browser";
import {Observable, Subscription, interval, timer} from 'rxjs';
import { take, scan, takeWhile, last, merge } from 'rxjs/operators';
import { ElectronService } from 'ngx-electron';

// import { Species } from "../classes/classes";


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  public debug:boolean = false;

  private datasServer:any;
  public datasName:any;
  public base:string;
  public datas:any;
  public datasdev:any;

  private activityDelay:number = 5*60*1000; //ms
  private activitySubscription:Subscription;

  public debugTxt:string;

  public current:string = 'loading';

  public bgImage:any;

  public isVP:any;

  private videoFolders:any;
  public currentVideo:string;
  private videoSubscription:Subscription;
  public loop:boolean;

  private espaces:Array<any> = [
    {
      name: 'Végétale',
      color: '#fbab18'
    },
    {
      name: 'Animale',
      color: '#ee4991'
    },
    {
      name: 'Humaine',
      color: '#00aab0'
    },
    {
      name: 'Artificielle',
      color: '#ef4023'
    }
  ];

  public indexOfSet:number;
  public deck:Array<any>;

  public espace = this.espaces[3];

  public areYouAnswer:string;
  public suffix:string;
  public step:number;
  public stepsNb:number;
  public walking:boolean;


  public instruction;
  public question;
  public questionBgImage:any;



  public answers:Array<any>;
  public success:boolean;





  @ViewChild('video', {static: false}) videoTag : ElementRef;
  videoProgress:number = 0;
  videoPlaying:boolean;
  noVideo:boolean;

  constructor(
    private service: MainService,
    public sanitizer:DomSanitizer,
    private titleService: Title,
    private electron: ElectronService
  ) { }

  ngOnInit():void
  {
    this.log('ngOnInit');

    if (window.hasOwnProperty('process') && window['process'].hasOwnProperty('versions') && window['process']['versions'].hasOwnProperty('electron')) { // electron
      let response: any = this.electron.ipcRenderer.sendSync('ping');
      this.datasName = response.datas;
      this.service.base = response.base;
      this.base = this.service.base;
    } else {
      this.datasName = this.findGetParameter('datas');
      this.base = AppConfig.datasServer;
    }
    this.log("this.datasName", this.datasName);

    this.checkIfVP();
    this.loadDatas();

    window.addEventListener('idal-contact-event', (e) => {
      let info = e['detail'];
      this.log("Input contact name: " + info.name);
      let port = info.values.findIndex(elt => elt);
      if (port == 0){

      }
    });
  }

  checkIfVP():void
  {
    // Detect Wave System player in VP330 ou VP320
    this.isVP = navigator.userAgent.search("WSPlayer") != -1;
  }

  loadDatas():void
  {
    this.current = 'loading';
    this.service.loadDatas(this.datasName).subscribe((datas => {
      this.datas = datas;
      console.log(this.datas);
      this.titleService.setTitle( this.datas.name );
      this.service.loadVideoFolders(this.datasName).subscribe((datas) => {
        this.videoFolders = datas;
        this.start();
      });
    }));
    // this.service.loadDatasDev(this.datasName).subscribe((datas => {
    //   this.datasdev = datas;
    // }));
  }

  start():void
  {
    this.bgImage = this.sanitizer.bypassSecurityTrustStyle('url('+ this.base+this.datasName+'/files/'+this.datas.image +')');
    this.goHome();
    // this.showQuestion(0);
  }

  clear():void
  {
    this.instruction = '';
    this.success = false;
    delete this.question;
    this.step = 0;
    this.walking = false;
  }

  goHome():void
  {
    this.clear();
    this.current = 'splash';
  }
  onSplashClick():void
  {
    if (AppConfig.name == 'web'){
      if (!document.fullscreenElement){ document.documentElement.requestFullscreen(); }
    }
    this.nextDeck(this.datas.questions);
    this.stepsNb = this.deck.length + 1;
    this.startGame();
  }
  nextDeck(datasDeck:Array<any>):void
  {
    let setsIds = [... new Set(datasDeck.map((data) => data.set))].sort();
    if (this.indexOfSet == undefined){
      this.indexOfSet = -1;
    }
    this.indexOfSet = (this.indexOfSet + 1) % setsIds.length;
    this.deck = datasDeck.filter((elt) => elt.set == setsIds[this.indexOfSet]);
    this.deck.sort((a, b) => {
      let ret = 0;
      if (a.order != undefined && b.order != undefined){
        if (a.order > b.order){
          ret = 1;
        } else {
          ret = -1;
        }
      }
      return ret;
    });
    console.log(this.deck.map(elt => elt.order));
  }


  onClick():void
  {
    if (this.activitySubscription){
      this.activitySubscription.unsubscribe();
      delete this.activitySubscription;
    }
    this.activitySubscription = timer(this.activityDelay).subscribe(() => {
      this.log("activitySubscription");
      window.location.href = window.location+"index.html";
      // this.goHome();
    });
  }

  startGame():void
  {
    this.showAreYou();
  }

  showAreYou(){
    this.current = 'areYou';
    // this.instruction = true;
    this.areYouAnswer = '';
  }
  onAreYou(answer:string):void
  {
    this.areYouAnswer = answer;
  }
  onOk(robot_or_human:string):void
  {
    this.suffix = '';
    if (robot_or_human == 'human'){
      this.suffix = '_human';
    }
    this.walk();
    this.current = '';
    timer(2000).subscribe(() => {
      this.stop();
      this.showQuestion(0);
    });
  }
  walk(){
    this.walking = true;
    this.step++;
  }
  stop(){
    this.walking = false;
  }
  showQuestion(index:number):void
  {
    this.current = 'question';
    this.success = false;
    this.question = this.deck[index];
    this.questionBgImage = this.sanitizer.bypassSecurityTrustStyle('url('+ this.base+this.datasName+'/files/'+this.question.image +')');
    console.log('showNextQuestion', index, this.question);
    this.answers = [];
    this.question.answers.forEach((answer) => {
      this.answers.push({
        answer: answer,
        error: false
      });
      this.answers.sort(() => 1-Math.random());
    });
  }
  showNextQuestion():void
  {
    let index = this.currentQuestionIndex();
    index++;
    if (index <= this.deck.length-1){
      this.showQuestion(index);
    } else {
      delete this.question;
      this.showConclusion();
    }
  }
  currentQuestionIndex():number
  {
    return this.deck.indexOf(this.question);
  }
  onAnswer(answer):void
  {
    // this.answers.forEach(a => a.error = false);
    if (answer.answer.correct == 'Oui'){
      this.success = true;
    } else {
      answer.error = true;
    }
  }
  onNext():void
  {
    this.walk();
    this.current = '';
    timer(2000).subscribe(() => {
      this.stop();
      this.showNextQuestion();
    });

  }
  showConclusion():void
  {
    this.current = 'conclusion';
  }
  onRestart():void
  {
    this.goHome();
  }


  /**********************************************************************/
  /* VIDEO *************************************************************/

  playVideoFile(file:string):void
  {
    this.log('***********');
    this.current = 'video';
    this.currentVideo = file;
    this.videoSubscription = interval(1000).subscribe(() => {
      this.videoUpdate();
    });

    this.log('current', this.current);
  }

  // playVideo(folderBaseAndInc, loop){
  //   let folder:string = folderBaseAndInc.base;
  //
  //   let folderSplit = folder.split('*');
  //   if (folderSplit.length > 1){
  //     let num = parseInt(folderSplit.shift());
  //     if (folderBaseAndInc.inc != null){
  //       num += folderBaseAndInc.inc;
  //     }
  //     folder = this.toStringLen(num, 3) + folderSplit.join('');
  //   }
  //
  //   if (this.isVP){
  //     this.playVideoExt(folder);
  //   } else {
  //     this.playVideoWeb(folder, loop);
  //   }
  // }

  playVideoWeb(videoFolder:string, loop:boolean):void
  {
    this.loop = loop;

    let sel = this.videoFolders.filter((elt) => elt.folder == videoFolder);
    if (sel.length){
      this.currentVideo = videoFolder+'/'+sel[0].video;
      this.videoSubscription = interval(1000).subscribe(() => {
        this.videoUpdate();
      });
    }

  }
  playVideoExt(videoFolder:string):void
  {
    this.currentVideo = videoFolder;

    let folderSplit = videoFolder.split('/');
    let folderNum = parseInt(folderSplit.shift());
    // let toPlay = this.videoFolders.filter((videoFolder) => video == videoFolder.video);
    // let folder = parseInt(toPlay[0].folder);

    this.log(window['IDAL'].getControlInterfaces);
    window['IDAL'].getControlInterfaces().then((ifaces) => {
      this.log('got ifaces');
      this.log("load", folderNum);

      ifaces.player.stop().then(() => {
        ifaces.player.playFolder(folderNum).then((ret) => {
          this.log('playing');
        }).catch(function(error) {
          this.log("control interface error");
          // Faire quelque chose d'utile...
        });
      });
    });
  }

  getPoster(videoSrc):void
  {
    return videoSrc.replace('.mp4', '.jpg');
  }
  videoUpdate():void
  {
    if (this.videoTag && this.videoTag.nativeElement){
      this.videoProgress = Math.round(100 * this.videoTag.nativeElement.currentTime / this.videoTag.nativeElement.duration);
    } else {
      this.videoProgress = 0;
    }
  }
  onVideoEnded(e):void
  {
    if (this.videoSubscription){
      this.videoSubscription.unsubscribe();
      delete this.videoSubscription;
    }
    this.videoProgress = 100;
    this.videoPlaying = false;
  }
  onTimeupdate(e):void
  {
    // if (this.videoSubscription){
    //   this.videoSubscription.unsubscribe();
    //   delete this.videoSubscription;
    // }
    // this.videoProgress = 100;
    //
  }
  onVideoClick():void
  {
    // this.current = 'splash';
  }

  /**********************************************************************/
  /* TOOLS **************************************************************/

  findGetParameter(parameterName:string):void
  {
      let result = null,
          tmp = [];
      let items = location.search.substr(1).split("&");
      for (let index = 0; index < items.length; index++) {
          tmp = items[index].split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      }
      return result;
  }

  toStringLen(num:number, len:number):string
  {
    let ret = ''+num;
    while(ret.length < len){
      ret = '0'+ret;
    }
    return ret;
  }

  log(...txts:any):void
  {
    if (true || this.isVP){
      this.debugTxt += txts.join(', ');
      this.debugTxt += '<br>';
    } else {
      this.log(...txts);
    }
  }

}
